<mat-card
  class="design-content__card  top-card summary-card mat-elevation-z0 black-border-color"
>
  <ip-board-extra-design
    [project]="project"
    [baseProject]="baseProject"
    [ipBoard]="ipBoard"
    (save)="save.emit()"
  ></ip-board-extra-design>
</mat-card>
